import React from "react"

export default function TextInput({
  label,
  name,
  className = "",
  multiline = false,
  rows = 0,
  required = false,
  subtle,
  ...props
}) {
  return (
    <div className={`${className} flex flex-col mb-4`}>
      {label && (
        <>
          <label htmlFor={name}>
            {label}{" "}
            {subtle && (
              <div className="text-md text-subtle inline-flex ">{subtle}</div>
            )}
            : {required && <span className="text-secondary">*</span>}
          </label>
        </>
      )}
      {multiline ? (
        <textarea
          className="input px-4 py-2 bg-transparent border-2 outline-none rounded-sm"
          required={required}
          name={name}
          rows={rows}
          {...props}
        />
      ) : (
        <input
          className="input px-4 py-2 bg-transparent border-2 outline-none rounded-sm"
          required={required}
          name={name}
          {...props}
        />
      )}
    </div>
  )
}
